import React from "react";
import { DialogContent, Typography, Box } from "@mui/material";
import RenderDialog from "shared-ui/src/components/RenderDialog";
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';

interface UseLegacyShiComDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
}


export const UseLegacyShiComDialog: React.FC<UseLegacyShiComDialogProps> = ({
  open,
  onClose,
  onConfirm,
  isLoading = false,
}) => {
  return (
    <RenderDialog
      open={open}
      onClose={onClose}
      title="Use Legacy SHI.com?"
      size="sm"
      onSave={onConfirm}
      saveButtonText="Revert to Legacy"
      saveButtonEndIcon={<ArrowForwardRoundedIcon />}
      cancelButtonText="Cancel"
      isSaving={isLoading}
      sx={{zIndex: 999999 }}
    >
      <DialogContent>
        <Typography
          variant="subtitle1"
          fontWeight="bold"
        >
          Are you sure you want to use Legacy SHI.com?
        </Typography>

        <Typography
          variant="body2"
        >
          Before switching, consider...
        </Typography>

        <Box component="ul">
          <Typography component="li" variant="body2" >
            The SHI One platform provides access to existing SHI.com features.
          </Typography>
          <Typography component="li" variant="body2">
            This reversion is temporary, in the future the platforms will be
            unified.
          </Typography>
        </Box>
      </DialogContent>
    </RenderDialog>
  );
};

export default UseLegacyShiComDialog;
